export enum EAdminUserQueryKey {
  ADMIN_USERS = 'ADMIN_USERS',
}
